import { AsyncPipe } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";
import { MultiSelectModule } from "primeng-v17/multiselect";
import { AppendToBodyDirective } from "../../../shared/primeng/append-to-body/append-to-body.directive";
import { MultiSelectEditableColumnAutoFocusDirective } from "../../../shared/primeng/multi-select-editable-column-auto-focus/multi-select-editable-column-auto-focus.directive";
import { MultiSelectReadonlyFixDirective } from "../../../shared/primeng/multi-select-readonly-fix/multi-select-readonly-fix.directive";
import { MultiSelectSelectedItemsLabelDirective } from "../../../shared/primeng/multi-select-selectedItemsLabel/multi-select-selectedItemsLabel.directive";
import { MultiSelectSortSelectedValuesOnTopDirective } from "../../../shared/primeng/multi-select-sort-selected-values-on-top/multi-select-empty.directive";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { NewUiDocumentTypeSelectorComponent } from "./new-ui-document-type-selector.component";

@Component({
  selector: "app-document-type-selector",
  templateUrl: "./document-type-selector.component.html",
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: DocumentTypeSelectorComponent, multi: true }],
  imports: [
    TranslateDirective,
    MultiSelectModule,
    AppendToBodyDirective,
    MultiSelectEditableColumnAutoFocusDirective,
    MultiSelectReadonlyFixDirective,
    MultiSelectSelectedItemsLabelDirective,
    MultiSelectSortSelectedValuesOnTopDirective,
    FormsModule,
    AsyncPipe,
  ],
})
export class DocumentTypeSelectorComponent extends NewUiDocumentTypeSelectorComponent {}
